module.exports = __webpack_public_path__ + "assets/img/11a.b6e64e8d.jpg";